import React from 'react';
import { Link } from 'react-router-dom';
import { CustomTable } from '../CustomTable/CustomTable';
import { CustomTablev2 } from '../CustomTable/CustomTablev2';
import { Container, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './CheckResult.scss';

/**
 * Display the result of a request/check from form submit as a message or as a table of data
 *
 * @component - CheckResults
 * @parentComponents - ViolationCheck and VignetteCheck
 */

interface Props {
  data: any;
  type: string;
  isDirty?: boolean;
  hash?: string;
}

const getHash = () => {
  const urlSplit = window.location.href.split('?')
  return new URL(urlSplit[0]).hash || ''
}

const CheckResults = (props: Props) => {
  const { t, i18n } = useTranslation();
  const hash = getHash();

  const getCountryByCode = (code: string) => {
    //@ts-ignore
    return i18n.getDataByLanguage(i18n.language).translations[`countryCode.${code.toUpperCase()}`];
  };

  if (props.isDirty) return null;

  if (!props.data.data && !props.data.error) {
    return null;
  }

  if (props.data.error) {
    // render request error
    return (
      <Container className="CheckResult">
        <Alert variant="warning">
          {t('Възникна проблем:')} {props.data.data.error}
          <br />
          {t('Моля, опитайте отново по-късно.')}
        </Alert>
      </Container>
    );
  }

  if (!props.data.data.ok) {
    // render result error
    return (
      <Container className="CheckResult">
        <Alert variant="warning">{t(props.data.data.status.message)}</Alert>
      </Container>
    );
  }

  if (props.type === 'vignette' && props.data.data.vignette && props.data.data.vignette.exempt) {
    // render exempt/whitelisted number
    return (
      <Container className="CheckResult">
        <Alert variant="success">
          {t('vignette.exempt.text')}{' '}
          {props.data.data.vignette.validityDateToFormated}
        </Alert>
      </Container>
    );
  } else if (props.type === 'vignette') {
    // render table result

    const TABLE_HEADER = [
      t('Table.th.vignetteNumber'),
      t('Table.th.vehicleClass'),
      t('Table.th.emissionsClass'),
      t('Table.th.validFrom'),
      t('Table.th.validTo'),
      t('Table.th.amount'),
      t('Table.th.status')
    ];

    const FIELDS_TO_RENDER: { [key: string]: boolean } = {
      vignetteNumber: true,
      vehicleClass: true,
      emissionsClass: true,
      validityDateFromFormated: true,
      validityDateToFormated: true,
      price: true,
      status: true
    };

    return (
      <Container className="CheckResult">
        <CustomTable data={[props.data.data.vignette]} header={TABLE_HEADER} fields={FIELDS_TO_RENDER} />
      </Container>
    );
  } else if (hash === '#/violation') {
    if (!props.data.data.delictList.length) {
      return (
        <Container className="CheckResult">
          <Alert variant="success"> {t(props.data.data.status.message)}</Alert>
        </Container>
      );
    }


    let TABLE_HEADER = [
      //t('Table.th.country'),
      t('Table.th.docNumber'),
      t('Table.th.delictDate'),
      t('Table.th.licensePlate'),
      t('Table.th.evidrecordType'),
      t('Table.th.amount'),
      t('Table.th.status'),
      t('Table.th.desc')
    ];

    let FIELDS_TO_RENDER: { [key: string]: boolean } = {
      documentNumber: true,
      delictDate: true,
      licenseplate: true,
      evidrecordType: true,
      amount: true,
      documentStatus: true,
      description: true,
      showPayment: true,
      //country: true,
      //documentNumber: true,
      //paid: true
    };

    // props.data.data.delictList.forEach((delict: any) => {
    //   // if (delict.documentStatus === 'paid') {
    //   //   TABLE_HEADER.push('');
    //   //   FIELDS_TO_RENDER.showPayment = true;     
    //   // }
    //   if (delict.orderId === null) {
    //     TABLE_HEADER.push('');
    //     FIELDS_TO_RENDER.showPayment = true;
    //     console.log('няма плащане към момента');        
    //   }
    //   if (delict.orderId !== null && delict.responseCode === null) {
    //     TABLE_HEADER.push('');
    //     console.log('Плащането се извършва в момента. Моля, изчакайте.');
    //   }
    //   if ((delict.orderId !== null && delict.responseCode !== null) && delict.responseCode !== '00') {
    //     console.log('Грешка при плащане');
    //     FIELDS_TO_RENDER.showPayment = true;
    //   }
    // });

    return (
      <Container className="CheckResult">
        <div className="paymentInfo">
          <Link to="/payment">{t('Как да платя ?')}</Link>
        </div>
        <CustomTablev2
          data={props.data.data.delictList}
          header={TABLE_HEADER}
          fields={FIELDS_TO_RENDER}
          getCountryByCode={getCountryByCode}
        />
      </Container>
    );
  } else if (hash === '#/violation/plate') {
      if (!props.data.data.delictList.length) {
        return (
          <Container className="CheckResult">
            <Alert variant="success"> {t(props.data.data.status.message)}</Alert>
          </Container>
        );
      }
      const TABLE_HEADER = [
        //t('Table.th.country'),
        t('Table.th.docNumber'),
        t('Table.th.delictDate'),
        t('Table.th.licensePlate'),
        t('Table.th.evidrecordType'),
        t('Table.th.amount'),
        t('Table.th.status'),
        t('Table.th.desc')
      ];
  
      const FIELDS_TO_RENDER: { [key: string]: boolean } = {
        documentNumber: true,
        delictDate: true,
        licenseplate: true,
        evidrecordType: true,
        amount: true,
        documentStatus: true,
        description: true,
        showPayment: true
        //country: true,
        //documentNumber: true,
        //paid: true
      };
      return (
        <Container className="CheckResult">
          <div className="paymentInfo">
            <Link to="/payment">{t('Как да платя ?')}</Link>
          </div>
          <CustomTablev2
            data={props.data.data.delictList}
            header={TABLE_HEADER}
            fields={FIELDS_TO_RENDER}
            getCountryByCode={getCountryByCode}
          />
        </Container>
      );
  } else if (hash === '#/violation/delict') {
    if (!props.data.data.delictList.length) {
      return (
        <Container className="CheckResult">
          <Alert variant="success"> {t(props.data.data.status.message)}</Alert>
        </Container>
      );
    }

    const TABLE_HEADER = [
      //t('Table.th.licensePlate'),
      //t('Table.th.country'),
      t('Table.th.docNumber'),
      t('Table.th.delictDate'),
      t('Table.th.licensePlate'),
      t('Table.th.evidrecordType'),
      t('Table.th.amount'),
      t('Table.th.status'),
      t('Table.th.desc')
    ];

    const FIELDS_TO_RENDER: { [key: string]: boolean } = {
      documentNumber: true,
      delictDate: true,
      licenseplate: true,
      evidrecordType: true,
      amount: true,
      documentStatus: true,
      description: true,
      showPayment: true,
	    //
      //country: true,
      //paid: true,
    };

    return (
      <Container className="CheckResult">
        <div className="paymentInfo">
          <Link to="/payment">{t('Как да платя ?')}</Link>
        </div>
        <CustomTablev2
          data={props.data.data.delictList}
          header={TABLE_HEADER}
          fields={FIELDS_TO_RENDER}
          getCountryByCode={getCountryByCode}
        />
      </Container>
    );
  } else if (hash === '/violation/reference') {
    if (!props.data.data.delictList.length) {
      return (
        <Container className="CheckResult">
          <Alert variant="success"> {t(props.data.data.status.message)}</Alert>
        </Container>
      );
    }

    const TABLE_HEADER = [
      //t('Table.th.country'),
      t('Table.th.docNumber'),
      t('Table.th.delictDate'),
      t('Table.th.licensePlate'),
      t('Table.th.evidrecordType'),
      t('Table.th.amount'),
      t('Table.th.status'),
      t('Table.th.desc')
    ];

    const FIELDS_TO_RENDER: { [key: string]: boolean } = {
      documentNumber: true,
      delictDate: true,
      licenseplate: true,
      evidrecordType: true,
      amount: true,
      documentStatus: true,
      description: true,
      showPayment: true,
      //country: true,
      //
      //paid: true
    };

    return (
      <Container className="CheckResult">
        <div className="paymentInfo">
          <Link to="/payment">{t('Как да платя ?')}</Link>
        </div>
        <CustomTablev2
          data={props.data.data.delictList}
          header={TABLE_HEADER}
          fields={FIELDS_TO_RENDER}
          getCountryByCode={getCountryByCode}
        />
      </Container>
    );
  }else if (hash === '#/violation/v2/plate') {
    if (!props.data.data.delictList.length) {
      return (
        <Container className="CheckResult">
          <Alert variant="success"> {t(props.data.data.status.message)}</Alert>
        </Container>
      );
    }
    const TABLE_HEADER = [
      //t('Table.th.country'),
      t('Table.th.docNumber'),
      t('Table.th.delictDate'),
      t('Table.th.licensePlate'),
      t('Table.th.evidrecordType'),
      t('Table.th.amount'),
      t('Table.th.status'),
      t('Table.th.desc')
    ];

    const FIELDS_TO_RENDER: { [key: string]: boolean } = {
      documentNumber: true,
      delictDate: true,
      licenseplate: true,
      evidrecordType: true,
      amount: true,
      documentStatus: true,
      description: true,
      showPayment: true
      //country: true,
     
      //paid: true
    };
    return (
      <Container className="CheckResult">
        <div className="paymentInfo">
          <Link to="/payment">{t('Как да платя ?')}</Link>
        </div>
        <CustomTablev2
          data={props.data.data.delictList}
          header={TABLE_HEADER}
          fields={FIELDS_TO_RENDER}
          getCountryByCode={getCountryByCode}
        />
      </Container>
    );
  } else {
    return null;
  }
};

export default CheckResults;
